// PersonIconFilled.js
import PropTypes from "prop-types";
import colors from "assets/theme/base/colors";

function PersonIconFilled({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={colors[color] ? colors[color].main : colors.dark.main}
    >
      <title>person-icon-filled</title>
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
    </svg>
  );
}

// Setting default values for the props of PersonIconFilled
PersonIconFilled.defaultProps = {
  color: "dark",
  size: "24px",
};

// Typechecking props for the PersonIconFilled
PersonIconFilled.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "white",
  ]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default PersonIconFilled;
